export default {"src":"/_next/static/media/credit-card-link.7d09b5d1.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};